module.exports = __webpack_public_path__ + "img/ic-arrow.39d06c13.svg";